import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=62b421ed&scoped=true"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"
import style0 from "./pay.vue?vue&type=style&index=0&id=62b421ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b421ed",
  null
  
)

export default component.exports